const VALIDATION_CONF = {
  FURIGANA: '^[あ-ん０-９ 　ー]+$',
  PHONE_NUMBER: '^(\\(\\d+\\))?(\\d+-)*\\d+$',
  ZIP_CODE: '^\\d{3}-\\d{4}$',
};

const isFurigana = (str) => {
  if (str.match(VALIDATION_CONF.FURIGANA)) {
    return true;
  } else {
    return false;
  }
};


const isPhoneNumber = (str) => {
  if (str.match(VALIDATION_CONF.PHONE_NUMBER)) {
    return true;
  } else {
    return false;
  }
};

const isZipCode = (str) => {
  if (str.match(VALIDATION_CONF.ZIP_CODE)) {
    return true;
  } else {
    return false;
  }
};

export {
  isFurigana,
  isPhoneNumber,
  isZipCode,
};
